import { render, staticRenderFns } from "./tongue.vue?vue&type=template&id=774067a6&scoped=true&"
import script from "./tongue.vue?vue&type=script&lang=ts&"
export * from "./tongue.vue?vue&type=script&lang=ts&"
import style0 from "./tongue.vue?vue&type=style&index=0&id=774067a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774067a6",
  null
  
)

export default component.exports